import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import {
  linksDetails,
  ProgressData,
  SaleData,
} from '@core/interfaces/partners-ALI'; // Importación de la interfaz para los detalles de enlaces
import { PartnersALIService } from '@core/services/partners-ALI/partners-ALI.service'; // Servicio para manejar los datos de partners
import { Subscription, take } from 'rxjs'; // Operadores y tipos de datos de RxJS
import {
  filesAliPartners,
  levelsAliPartners,
  partnerNotMessages,
  remindersAliPartners,
} from 'src/assets/data/partners-ALI-fixed-data'; // Datos estáticos para los partners
import * as fs from 'file-saver'; // Librería para la descarga de archivos
import { LocalStorageService } from '@core/services/local-storage.service'; // Servicio para manejo de localStorage
import { MatSnackBar } from '@angular/material/snack-bar'; // Servicio para mostrar notificaciones
import { CustomSnackBarComponent } from '@shared/components/custom-snack-bar/custom-snack-bar.component'; // Componente para el SnackBar personalizado
import { Router } from '@angular/router'; // Servicio de navegación de Angular
import { TermsConditionsComponent } from '@shared/components/terms-conditions/terms-conditions.component';
import {
  MessageAlliesProgressError,
} from 'src/assets/data/errors-message';
import { GtmEventService } from '@core/analytics/gtm-events.service';

@Component({
  selector: 'app-partners-ALI',
  templateUrl: './partners-ALI.component.html',
  styleUrls: ['./partners-ALI.component.scss'],
})
export class PartnersALIComponent implements OnInit, OnDestroy {
  saleData: SaleData | null = null;
  // Función Math para usar en el template
  readonly Math = Math;

  // Datos iniciales
  readonly levels = levelsAliPartners; // Niveles de clientes
  readonly reminders = remindersAliPartners; // Recordatorios
  readonly filesAliPartners = filesAliPartners; // Archivos de partners
  readonly partnerNotMessages = partnerNotMessages; // Mensajes de partners

  // Suscripción de datos
  partnersALISuscription$!: Subscription;
  dataLink: linksDetails | undefined = undefined;

  // Estado de carga y datos del cliente
  loadingPDf = false;
  userDataSetting!: string | null;
  userDataSegment!: string | null;
  nameClient!: string;
  snackBarRef: any;
  showTermsConditions: boolean = false;
  selectorBelongs: boolean = false;

  // Propiedades para el contenedor de progreso
  readonly currentYear: number = new Date().getFullYear();
  readonly mockProgressData: ProgressData = {
    currentAmount: 0,
    progressPercentage: 0,
    avatarPosition: 0,
    animatedProgress: 0,
    remainingForSilver: 0,
    remainingForGold: 0,
    silverProgress: 0,
    monthlyAverage: 0,
  };
  readonly messageAlliesProgressError = [MessageAlliesProgressError];
  
  @ViewChild('avatarElement', { static: false }) avatarRef!: ElementRef;
  offerByCodsLoading: boolean = false;
  offerByCodsError: boolean = false;
  partnersALISubscription!: Subscription;
  // Constructor para inyectar dependencias
  constructor(
    private readonly _partnersALIService: PartnersALIService,
    public readonly _localStorageService: LocalStorageService,
    private readonly _snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly _gtmEventService: GtmEventService
  ) {}

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const doc = document.documentElement;
    // Scroll de toda la página
    this._gtmEventService.trackScrollProgress(
      'ali-socios-page',
      {
        scrollTop: doc.scrollTop || document.body.scrollTop,
        scrollHeight: doc.scrollHeight,
        clientHeight: doc.clientHeight,
      },
      'Aliados beneficios'
    );
    // Scroll a través de la sección "Beneficios"
    const benefits = document.getElementById('ver-beneficios');
    if (benefits) {
      const rect = benefits.getBoundingClientRect();
      this._gtmEventService.trackScrollProgress(
        'ali-socios-benefits',
        {
          scrollTop: -rect.top,
          scrollHeight: benefits.offsetHeight,
          clientHeight: doc.clientHeight,
        },
        'Aliados beneficios',
        'Beneficios'
      );
    }
  }

  ngOnInit() {
    this._gtmEventService.resetScrollProgress('ali-socios-page');
    this._gtmEventService.resetScrollProgress('ali-socios-benefits');
    this.valueOfferByCod();
    // Cargar datos del cliente dependiendo de la URL actual
    if (this.router.url === '/main/ali-socios') {
      const userInfo = this._localStorageService.getItem('clientSelect');
      this.nameClient = `${userInfo.name} - ${userInfo.code}`;
      this.userDataSetting = userInfo?.setting?.isPartner;
      this.userDataSegment = userInfo?.segment;
      this.selectorBelongs = userInfo?.sector == '0010';
    } else {
      const userInfo = this._localStorageService.getItem('user');
      this.nameClient = `${userInfo.name} - ${userInfo.code}`;
      this.userDataSetting = userInfo?.setting?.isPartner;
      this.userDataSegment = userInfo?.sectors?.find(
        (sector) => sector.sector == '0010'
      )?.segment;
      this.selectorBelongs =
        this._localStorageService.getItem('sectorSelect')?.sector == '0010';
    }
    if (this.isUserDataValid()) {
      this.loadFiles(); // Cargar los archivos relacionados con el partner
    }
  }
 
  isUserDataValid(): boolean {
    return (
      !!this.userDataSetting &&
      this.selectorBelongs &&
      ['B', 'A', 'A+', '1T'].includes(this.userDataSegment?.trim() ?? '')
    );
  }

  // Mostrar el SnackBar de términos y condiciones
  showTermsConditionsSnackBar(): void {
    this.snackBarRef = this._snackBar.openFromComponent(
      TermsConditionsComponent,
      {
        data: {
          message: 'Términos y Condiciones',
          actionText: this.dataLink?.terms,
          customerCode:
            this.router.url === '/main/ali-socios'
              ? this._localStorageService.getItem('clientSelect')?.code
              : this._localStorageService.getItem('user')?.code,
          userType:
            this.router.url === '/main/ali-socios' ? 'seller' : 'client',
        },
        panelClass: ['terms-conditions-snackbar'],
      }
    );

    // Suscribirse al estado de aceptación de términos
    setTimeout(() => {
      if (this.snackBarRef.instance?.termsStatus$) {
        this.snackBarRef.instance.termsStatus$.subscribe((status: boolean) => {
          this.showTermsConditions = status;
          this.cdr.detectChanges();
        });
      }
    });
  }

  // Cargar archivos del servicio de partners
  loadFiles() {
    this.partnersALISuscription$ = this._partnersALIService
      .getAliPartnersFiles()
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.dataLink = res;
          // Asignar las URLs de los archivos obtenidos
          if (this.dataLink) {
            this.filesAliPartners[0].url = this.dataLink.terms;
            this.filesAliPartners[1].url = this.dataLink.questions;
            this.filesAliPartners[2].url = this.dataLink.formats;
          } else {
            this.dataLink = undefined;
          }
          this.showTermsConditionsSnackBar();
        },
        error: (err: Error) => {
          this.dataLink = undefined; // Manejar error
          this.showTermsConditionsSnackBar();
        },
      });
  }
  // Cargar archivos del servicio de partners
  valueOfferByCod(): void {
    this.offerByCodsLoading = true;
    this.offerByCodsError = false;
    let body: {
      code: string;
      sector: string;
    } = {
      code:
        this.router.url === '/main/ali-socios'
          ? this._localStorageService.getItem('clientSelect')?.code
          : this._localStorageService.getItem('user')?.code,
      sector:
        this.router.url === '/main/ali-socios'
          ? this._localStorageService.getItem('clientSelect')?.sector
          : this._localStorageService.getItem('sectorSelect')?.sector,
    };
    this.partnersALISubscription = this._partnersALIService
      .getValueOfferByCods(body)
      .pipe(take(1))
      .subscribe({
        next: (res: any) => {
          this.offerByCodsLoading = false;
          this.saleData = res; // Aquí puedes mapear si lo necesitas
          
        },
        error: (err: any) => {
          this.offerByCodsLoading = false;
          this.offerByCodsError = true;
        },
      });
  }
  // Obtener el nivel activo según el segmento del usuario
  obtenerNivelActivo() {
    return (
      this.levels?.find((nivel) => nivel.segment == this.userDataSegment) || {
        type: '',
        name: '',
        icon: '',
      }
    );
  }

  openFileInNewWindow(file: any) {
    // Verificar si ya está en proceso de descarga
    if (file.loading) {
      return; // Evitar hacer clic si el archivo ya está en descarga
    }
    // Activar el loader para indicar que el archivo está descargando
    file.loading = true;
    // Verificar si la URL del archivo es válida
    if (!file.url || file.url.trim() === '') {
      file.loading = false;
      this.showSnackBar(
        'Oops, ocurrió un error',
        'X',
        'custom-snack-bar-error'
      );
      return;
    } else {
      // Descargar el archivo
      fs.saveAs(file.url, file.name);

      // Desactivar el loader después de la descarga
      setTimeout(() => {
        file.loading = false;
      }, 2000); // Simulamos el tiempo para completar la descarga
    }
  }
  scrollToBenefitsSection() {
    const element = document.getElementById('ver-beneficios');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start', // 👈 Esto asegura que se alinee al inicio
      });
    }
  }

  // Abrir archivo PDF
  openFilePDF() {
    if (this.loadingPDf) {
      return; // Evitar que se ejecute si ya está en proceso de carga
    }

    this.loadingPDf = true; // Activar el loading
    if (this.dataLink?.benefits) {
      // Descargar el archivo PDF
      fs.saveAs(this.dataLink?.benefits, 'Beneficios');
      this._gtmEventService.fileDownloadEvent({
        fileExtension: 'pdf',
        fileName: 'Preguntas y Respuestas Ali Socios.pdf',
        linkText: 'Descargar PDF',
      });
      // Después de un tiempo, desactivar el loading (simulando tiempo de descarga)
      setTimeout(() => {
        this.loadingPDf = false;
      }, 2000);
    } else {
      this.showSnackBar(
        'Oops, ocurrió un error',
        'X',
        'custom-snack-bar-error'
      );
      this.loadingPDf = false; // Desactivar el loading si hay error
    }
  }

  // Abrir video en una nueva ventana
  openVideo() {
    if (this.dataLink?.video && this.dataLink.video.length > 0) {
      this._gtmEventService.clickElementEvent({
        cta: 'Enterate mas con este video',
        seccion: 'Aliados beneficios',
        subSeccion: 'Nuestro programa',
      });
      window.open(this.dataLink.video, '_blank', 'noopener');
    } else {
      this.showSnackBar(
        'Oops, ocurrió un error',
        'X',
        'custom-snack-bar-error'
      );
    }
  }

  // Mostrar un SnackBar personalizado
  showSnackBar(
    message: string,
    actionText: string,
    panelClass: string,
    actionCallback?: () => void
  ): void {
    const snackBarRef = this._snackBar.openFromComponent(
      CustomSnackBarComponent,
      {
        data: { message, actionText, actionCallback },
        duration: 5000,
        panelClass: [panelClass],
      }
    );

    snackBarRef.afterDismissed().subscribe(() => {
      this.showTermsConditionsSnackBar();
    });
  }

  // Desuscribir la suscripción cuando el componente se destruye
  unsubscribeFromStorePartners() {
    if (this.partnersALISuscription$) {
      this.partnersALISuscription$.unsubscribe();
    }
  }

  // Lifecycle hook: ngOnDestroy
  ngOnDestroy(): void {
    this.unsubscribeFromStorePartners();
    // Cerrar todos los snackbars activos
    this._snackBar.dismiss();
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
    if (this.partnersALISubscription) {
      this.partnersALISubscription.unsubscribe();
    }
  }
}

